import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const RugbyIcon = observer('RugbyIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='rugbyMask'
                width='13'
                height='13'
                x='2'
                y='2'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M6.079 14.088q-.783.084-1.892-.042-1.109-.125-1.692-.408-.233-.533-.391-1.667t-.075-1.933zm1.583-.267L2.295 8.455A9.2 9.2 0 0 1 3.12 6.18Q3.663 5.154 4.38 4.42A6.9 6.9 0 0 1 6.12 3.18a9.3 9.3 0 0 1 2.209-.792l5.4 5.4a9.6 9.6 0 0 1-.784 2.267 6.7 6.7 0 0 1-1.233 1.75q-.75.733-1.792 1.258a8.6 8.6 0 0 1-2.258.758m-1.367-3.05 4.4-4.4-.933-.933-4.4 4.4zm7.7-4.566L9.945 2.12q.801-.1 1.967.034 1.167.133 1.65.416.3.667.417 1.725t.016 1.909'
                />
            </mask>
            <g mask='url(#rugbyMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
